const isTestEnv = process.env.NODE_ENV === 'test';

export default isTestEnv;
